import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput, MatInputModule } from '@angular/material/input';

import { MatIconModule } from '@angular/material/icon';
import { FilterButtonComponent } from '../../../../core/components/filter-button/filter-button.component';
import { ContractorListFilter } from '../../../../core/models/contractors/contractor-list-filter';
import { ContractorListDto } from '../../../../core/models/contractors/contractor-list-dto';
import { ContractorListService } from '../../../../core/services/contractor-list/contractor-list.service';
import { LocalStorageService } from '../../../../core/services/localstorage/local-storage.service';
import { FilterInputChipsComponent } from '../../../../core/components/filter-input-chips/filter-input-chips.component';

@Component({
  selector: 'app-contractor-list-filter',
  imports: [MatFormField, MatLabel, ReactiveFormsModule, FormsModule, MatInput, MatIconModule, MatInputModule, FilterButtonComponent, FilterInputChipsComponent],
  templateUrl: './contractor-list-filter.component.html',
  styleUrl: './contractor-list-filter.component.scss',
  standalone: true
})
export class ContractListFilterComponent {
  filterValues!: ContractorListFilter;

  private contractors: ContractorListDto[] = [];
  allCities: string[] = [];
  allContractorListStatuses: string[] = [];
  searchTerm: string = '';

  constructor(
    private contractorListService: ContractorListService,
    private localStorage: LocalStorageService) {
    this.filterValues = this.localStorage.getContractorFilter();

    this.contractorListService.data$.subscribe(async contractorList => {
      this.contractors = contractorList ? contractorList : [];
      if (this.contractors) {
        this.initializeFilters();
      }
    })
  }

  ngAfterViewInit() {
    this.initializeFilters();
  }

  async initializeFilters() {
    this.allCities = [...new Set(this.contractors.map(wo => wo.city).filter(v => v))].sort();
    this.allContractorListStatuses = [...new Set(this.contractors.map(wo => wo.contractorListStatus).filter(v => v))].sort();
    this.searchTerm = this.filterValues.search.length === 1 ? this.filterValues.search[0].value : '';

    this.applyFilter();
  }

  applyFilter() {
    if (this.filterValues.search.length === 0) {
      this.searchTerm = '';
    }

    this.filterValues = { ...this.filterValues };
    this.contractorListService.applyFilter(this.filterValues);
    this.localStorage.saveContractorFilter(this.filterValues);
  }

  compareWith(compare1: any, compare2: any): boolean {
    return compare1 && compare2 && compare1.id === compare2.id;
  }

  filterSelectableValuesByQuery() {
    const hasSearchTerm = (this.searchTerm ?? '').trim().length > 0;

    if (!hasSearchTerm) {
      this.filterValues.search = [];
      this.applyFilter();
      return;
    }

    this.searchTerm = this.searchTerm.trim();

    if (!this.filterValues.search || this.filterValues.search.length === 0) {
      this.filterValues.search = [{ value: this.searchTerm, activated: true }];
    } else {
      this.filterValues.search[0].value = this.searchTerm;
      this.filterValues.search[0].activated = true;
    }

    this.applyFilter();
  }
}
